import {Component, OnInit} from '@angular/core';
import { CurrencyPipe } from "@angular/common";
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {PayService} from '../../services/pay/pay.service';
import {Payment} from '../../entities/pay/payment.entity';
import {UserService} from '../../../core/services/user/user.service';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-pay',
  imports: [
    TranslocoPipe,
    CurrencyPipe,
    ReactiveFormsModule
],
  templateUrl: './pay.component.html',
  styleUrl: './pay.component.scss'
})
export class PayComponent implements OnInit {
  public payments: Payment[] | null = null;
  public totalConfirmed = 0;
  public totalPending = 0;
  public form!: FormGroup;

  public constructor(
    private readonly payService: PayService,
    private readonly userService: UserService,
    private readonly fb: FormBuilder,
    private readonly toastr: ToastrService,
    private readonly transloco: TranslocoService,
  ) {
    this.form = this.fb.group({
      iban: ['', [Validators.required]],
      bic: ['', [Validators.required]]
    });
  }

  public ngOnInit() {
    this.payService.getPayments().subscribe(
      (payments) => {
        this.payments = payments;
        this.computeTotals();
      }
    );
  }

  public monthStatus(payment: Payment): 'ongoing' | 'done' {
    return payment.pending > 0 ? 'ongoing' : 'done';
  }

  private computeTotals(): void {
    if (!this.payments || this.payments.length === 0) {
      this.totalConfirmed = 0;
      this.totalPending = 0;
      return;
    }

    this.totalConfirmed = this.payments.reduce((sum, payment) => sum + payment.confirmed, 0);
    this.totalPending = this.payments.reduce((sum, payment) => sum + payment.pending, 0);
  }

  public savePaymentInfo(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const { iban, bic } = this.form.value;

    this.userService.updateUser(
      null, null, null, null, null, null, iban, bic
    ).subscribe({
      next: () => {
        this.toastr.success(
          this.transloco.translate('pay.form.success.content'),
          this.transloco.translate('pay.form.success.title')
        );
      },
      error: (err) => {
        this.toastr.success(
          this.transloco.translate('pay.form.error.content'),
          this.transloco.translate('pay.form.error.title')
        )
      }
    });
  }
}
